module.exports = __webpack_public_path__ + "./img/DestacadosArticulos.75e6886af87a101b3299249476f42004.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/DestacadosArticulos.png
// module id = ./public/img/Help/DestacadosArticulos.png
// module chunks = 0